export const getStreamShareProps = (slug?: string) => {
  return {
    text: 'Join the party! Interact and catch epic moments live on',
    url: `${window.location.origin}/watch/${slug}`,
  }
}

export const getHistoryChatFileName = (slug?: string) => {
  return `history-chat-${slug}.txt`
}
